import { productData } from '../../shared/store/modules/productData'

export const state = () => ({
    products: {},
    current_product: ''
})
export const mutations = productData.mutations
export const getters = productData.getters
export const actions = productData.actions